module.exports = __webpack_public_path__ + "static/media/vail-8.5e971a0d.jpg";